import React, { useState, useEffect } from 'react';
import './App.css';
import Loading from './components/Loading';
import Iridescence from './components/Iridescence';
import TextType from './components/TextType';
import Arrow from './assets/right.png';
import Logo from './assets/logo.png';
import Silk from './components/Silk';


function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simuler un temps de chargement de 2 secondes
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <main className="w-full h-screen overflow-y-scroll overflow-x-hidden snap-y snap-mandatory">
      {/* Background Layer - Fixed */}
      <div className="fixed inset-0 z-0">
        <Iridescence
          color={[0.5, 0.6, 0.8]}
          mouseReact={false}
          amplitude={0.1}
          speed={1.0}
        />
      </div>

      {/* Slide 1 - Home */}
      <section className="w-full h-screen snap-start relative z-10 flex flex-col items-center justify-start p-4 gap-10">
        <nav className="w-2/3 max-w-screen-lg mt-4">
          <div className='w-full h-14 rounded-full '>
            <div className='w-full h-14 bg-white bg-opacity-10 rounded-full border border-white border-opacity-10'>
              <div className='flex flex-row  h-14 opacity-100 items-center justify-between mx-2 sm:mx-4'>
                <div className='flex flex-row items-center gap-2'>
                  <img src={Logo} alt="logo" className='w-10 h-10 filter invert inline-block' />
                  <div className='poppins-medium text-sm sm:text-lg md:text-xl'>Lucas LANGRAND</div>
                </div>
                <div className='poppins-light text-xs sm:text-sm md:text-md text-right'>Etudiant ingénieur</div>
              </div>
            </div>
          </div>
        </nav>
        <div className="w-full h-2/3 flex flex-col items-center justify-center gap-4 poppins-bold text-6xl">
          <div className='bg-white mb-4 bg-opacity-10 rounded-full w-1/6 flex justify-center items-center py-2 border-white border-opacity-15 border'>
            <TextType
              text={["Informatique", "Aéronautique", "Physique", "Data/IA", "Fullstack"]}
              typingSpeed={75}
              pauseDuration={1500}
              showCursor={true}
              cursorCharacter="|"
              className='text-sm poppins-light'
            />
          </div>
          <div className="text-white glow-shadow">
            Découvrir
          </div>
          <div className="text-white glow-shadow">
            mon CV
          </div>

          <div className='flex flex-row text-sm justify-center gap-8 items-center mt-8'>
            <div className='bg-white py-4 px-8 text-black poppins-regular rounded-full'>Me contacter</div>
            <a href="https://www.linkedin.com/in/lucas-langrand" target="_blank" rel="noopener noreferrer" className='bg-white bg-opacity-10 py-4 px-8 text-white border border-white border-opacity-10 poppins-regular hover:bg-opacity-30 transition-all duration-300 hover:border-opacity-40 hover-scale-115 bg-pulse rounded-full'>LinkedIn</a>
          </div>
          <div className='text-sm mt-4 -mb-4 animate-bounce'>Scroll !</div>
          <div>
            <img src={Arrow} alt="arrow" className='glow-shadow w-12 h-12 animate-pulse  rotate-90 filter invert' />
          </div>
        </div>
      </section>

      {/* Slide 2 - À propos */}
      <section className="w-full h-screen snap-start relative z-10 flex flex-col items-center justify-center p-4">
        <div className="w-2/3 max-w-screen-lg text-center">
          <h2 className="text-5xl poppins-bold text-white glow-shadow mb-8">À propos</h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Description principale */}
            <div className="lg:col-span-2 flex flex-col justify-center bg-white bg-opacity-10 rounded-2xl border border-white border-opacity-10 p-8">
              <p className="text-xl poppins-light text-white leading-relaxed mb-8">
                Étudiant ingénieur passionné par l'informatique, l'aéronautique et la physique.
                Je développe des solutions innovantes en combinant mes connaissances techniques
                et ma créativité.
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-white bg-opacity-10 rounded-lg p-4">
                  <div className="text-2xl font-bold text-white">8+</div>
                  <div className="text-sm text-white opacity-80">Années d'expérience</div>
                </div>
                <div className="bg-white bg-opacity-10 rounded-lg p-4">
                  <div className="text-2xl font-bold text-white">10+</div>
                  <div className="text-sm text-white opacity-80">Projets réalisés</div>
                </div>
                <div className="bg-white bg-opacity-10 rounded-lg p-4">
                  <div className="text-2xl font-bold text-white">5+</div>
                  <div className="text-sm text-white opacity-80">Technologies</div>
                </div>
                <div className="bg-white bg-opacity-10 rounded-lg p-4">
                  <div className="text-2xl font-bold text-white">∞</div>
                  <div className="text-sm text-white opacity-80">Motivation</div>
                </div>
              </div>
            </div>

            {/* Encart Études */}
            <div className="bg-white bg-opacity-10 rounded-2xl border border-white border-opacity-10 p-6">
              <h3 className="text-2xl poppins-medium text-white mb-6">Études</h3>
              <div className="space-y-4">
                <div className="bg-white bg-opacity-5 rounded-lg p-4 text-left">
                  <div className="text-white font-medium text-sm mb-1">2025 - 2028</div>
                  <div className="text-white opacity-90 text-sm mb-2">Diplôme d'Ingénieur - PHELMA INP</div>
                  <div className="text-white opacity-70 text-xs">Physique, Electronique, Télécom</div>
                </div>
                <div className="bg-white bg-opacity-5 rounded-lg p-4 text-left">
                  <div className="text-white font-medium text-sm mb-1">2022 - 2025</div>
                  <div className="text-white opacity-90 text-sm mb-2">Licence de Physique</div>
                  <div className="text-white opacity-70 text-xs">Option mécanique</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Slide 3 - Compétences */}
      <section className="w-full h-screen snap-start relative z-10 flex flex-col items-center justify-center p-4">
        <div className="w-2/3 max-w-screen-lg text-center">
          <h2 className="text-5xl poppins-bold text-white glow-shadow mb-8">Compétences</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

            {/* Informatique */}
            <div className="bg-white bg-opacity-10 rounded-2xl border border-white border-opacity-10 p-6">
              <h3 className="text-2xl poppins-medium text-white mb-6">Informatique</h3>
              <div className="space-y-6">

                {/* Fullstack */}
                <div className="bg-white bg-opacity-5 rounded-xl p-4 border border-white border-opacity-5">
                  <h4 className="text-lg poppins-medium text-white mb-3">Fullstack</h4>
                  <div className="space-y-2">
                    {/* Frontend */}
                    <div className="bg-white bg-opacity-5 rounded-lg p-3">
                      <div className="text-white opacity-90 font-medium text-sm mb-2">Frontend</div>
                      <div className="pl-3">
                        <span className="inline-block bg-blue-500 bg-opacity-20 text-blue-200 px-3 py-1 rounded-full text-xs border border-blue-400 border-opacity-30">
                          React.js
                        </span>
                        <span className="inline-block bg-red-500 bg-opacity-20 text-blue-200 px-3 py-1 rounded-full text-xs border border-blue-400 border-opacity-30">
                          Tailwind CSS
                        </span>
                        <span className="inline-block bg-green-500 bg-opacity-20 text-blue-200 px-3 py-1 rounded-full text-xs border border-blue-400 border-opacity-30">
                          Three.js
                        </span>
                        <span className="inline-block bg-pink-500 bg-opacity-20 text-blue-200 px-3 py-1 rounded-full text-xs border border-blue-400 border-opacity-30">
                          Gsap
                        </span>
                      </div>
                    </div>
                    {/* Backend */}
                    <div className="bg-white bg-opacity-5 rounded-lg p-3">
                      <div className="text-white opacity-90 font-medium text-sm mb-2">Backend</div>
                      <div className="pl-3">
                        <span className="inline-block bg-green-500 bg-opacity-20 text-blue-200 px-3 py-1 rounded-full text-xs border border-blue-400 border-opacity-30">
                          Node.js
                        </span>
                        <span className="inline-block bg-pink-500 bg-opacity-20 text-blue-200 px-3 py-1 rounded-full text-xs border border-blue-400 border-opacity-30">
                          Dart
                        </span>
                        <span className="inline-block bg-blue-500 bg-opacity-20 text-blue-200 px-3 py-1 rounded-full text-xs border border-blue-400 border-opacity-30">
                          MongoDB
                        </span>
                        <span className="inline-block bg-red-500 bg-opacity-20 text-blue-200 px-3 py-1 rounded-full text-xs border border-blue-400 border-opacity-30">
                          Express.js
                        </span>

                      </div>
                    </div>
                  </div>
                </div>


                <div className='flex flex-row justify-between gap-4'>
                  {/* Data/IA */}
                  <div className="bg-white w-1/2 bg-opacity-5 rounded-xl p-4 border border-white border-opacity-5">
                    <h4 className="text-lg poppins-medium text-white mb-3">Data/IA</h4>
                    <div className="flex flex-wrap gap-2">
                      <span className="inline-block bg-purple-500 bg-opacity-20 text-purple-200 px-3 py-1 rounded-full text-xs border border-purple-400 border-opacity-30">
                        Python
                      </span>
                      <span className="inline-block bg-yellow-500 bg-opacity-20 text-purple-200 px-3 py-1 rounded-full text-xs border border-purple-400 border-opacity-30">
                        MATLAB
                      </span>
                    </div>
                  </div>

                  {/* AUTRE */}
                  <div className="bg-white w-1/2 bg-opacity-5 rounded-xl p-4 border border-white border-opacity-5">
                    <h4 className="text-lg poppins-medium text-white mb-3">Autre</h4>
                    <div className="flex flex-wrap gap-2">
                      <span className="inline-block bg-purple-500 bg-opacity-20 text-purple-200 px-3 py-1 rounded-full text-xs border border-purple-400 border-opacity-30">
                        C++
                      </span>
                      <span className="inline-block bg-indigo-500 bg-opacity-20 text-purple-200 px-3 py-1 rounded-full text-xs border border-purple-400 border-opacity-30">
                        Go
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            {/* Physique */}
            <div className="bg-white bg-opacity-10 rounded-2xl border border-white border-opacity-10 p-6">
              <h3 className="text-2xl poppins-medium text-white mb-6">Physique</h3>
              <div className="grid grid-cols-1 gap-3">
                <div className="bg-white bg-opacity-5 rounded-lg p-3 text-center">
                  <div className="text-white opacity-80 text-sm">Mécanique (des fluides, des solides, du point)</div>
                </div>
                <div className="bg-white bg-opacity-5 rounded-lg p-3 text-center">
                  <div className="text-white opacity-80 text-sm">Thermodynamique</div>
                </div>
                <div className="bg-white bg-opacity-5 rounded-lg p-3 text-center">
                  <div className="text-white opacity-80 text-sm">Électromagnétisme</div>
                </div>
                <div className="bg-white bg-opacity-5 rounded-lg p-3 text-center">
                  <div className="text-white opacity-80 text-sm">Optique</div>
                </div>
                <div className="bg-white bg-opacity-5 rounded-lg p-3 text-center">
                  <div className="text-white opacity-80 text-sm">Physique quantique</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Slide 4 - Expérience professionnelle */}
      <section className="w-full h-screen snap-start relative z-10 flex flex-col items-center justify-center p-4">
        <div className="w-2/3 max-w-screen-lg text-center">
          <h2 className="text-4xl poppins-bold text-white glow-shadow mb-6">Expérience professionnelle</h2>
          <div className="space-y-4">
            
            {/* Expérience 1 */}
            <div className="bg-white bg-opacity-10 rounded-xl border border-white border-opacity-10 p-4">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-3">
                <div className="text-left">
                  <h3 className="text-lg poppins-medium text-white">Développeur modèle système</h3>
                  <p className="text-white opacity-80 poppins-light text-sm">ATR - Airbus</p>
                </div>
                <div className="text-white opacity-70 text-xs poppins-light">
                  Mai 2025 - Juillet 2025
                </div>
              </div>
              <p className="text-white opacity-90 text-left leading-relaxed mb-3 text-sm">
                Mise à jour d’un système temps réel en C++/Python et utilisation d’un banc de test cockpit (type Alysa, Kaliste). Développement d’un lecteur audio pour les alertes et intégration d’un pedestal dans l’environnement de test.
              </p>
              <div className="flex flex-wrap gap-1 justify-start">
                <span className="bg-blue-500 bg-opacity-20 text-blue-200 px-2 py-1 rounded-full text-xs border border-blue-400 border-opacity-30">C++</span>
                <span className="bg-green-500 bg-opacity-20 text-green-200 px-2 py-1 rounded-full text-xs border border-green-400 border-opacity-30">Python</span>
                <span className="bg-yellow-500 bg-opacity-20 text-yellow-200 px-2 py-1 rounded-full text-xs border border-yellow-400 border-opacity-30">Alysa</span>
              </div>
            </div>

            {/* Expérience 2 */}
            <div className="bg-white bg-opacity-10 rounded-xl border border-white border-opacity-10 p-4">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-3">
                <div className="text-left">
                  <h3 className="text-lg poppins-medium text-white">Développeur Fullstack</h3>
                  <p className="text-white opacity-80 poppins-light text-sm">Freelance</p>
                </div>
                <div className="text-white opacity-70 text-xs poppins-light">
                  Mai 2024 - Aout 2024
                </div>
              </div>
              <p className="text-white opacity-90 text-left leading-relaxed mb-3 text-sm">
                Création de plusieurs site internet et applications web pour des clients divers. 
              </p>
              <div className="flex flex-wrap gap-1 justify-start">
                <span className="bg-purple-500 bg-opacity-20 text-purple-200 px-2 py-1 rounded-full text-xs border border-purple-400 border-opacity-30">Fullstack</span>
              </div>
            </div>

            {/* Expérience 3 */}
            <div className="bg-white bg-opacity-10 rounded-xl border border-white border-opacity-10 p-4">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-3">
                <div className="text-left">
                  <h3 className="text-lg poppins-medium text-white">Stage département informatique et laboratoire</h3>
                  <p className="text-white opacity-80 poppins-light text-sm">Bayer-Cropscience</p>
                </div>
                <div className="text-white opacity-70 text-xs poppins-light">
                  Février 2017 - Février 2017
                </div>
              </div>
              <p className="text-white opacity-90 text-left leading-relaxed mb-3 text-sm">
                Découverte des systèmes informatiques et des laboratoires de recherche.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Slide 5 - Portfolio */}
      <section className="w-full h-screen snap-start relative z-10 flex flex-col items-center justify-center p-4">
        <div className="w-2/3 max-w-screen-lg text-center">
          <h2 className="text-4xl poppins-bold text-white glow-shadow mb-6">Portfolio</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            
            {/* Projet 1 */}
            <div className="bg-white bg-opacity-10 rounded-xl border border-white border-opacity-10 p-4 hover:bg-opacity-15 transition-all duration-300">
              <div className="h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg mb-3 flex items-center justify-center">
                <div className="text-white text-xl poppins-bold">🚀</div>
              </div>
              <h3 className="text-lg poppins-medium text-white mb-2">Modèle MFC Airbus</h3>
              <p className="text-white opacity-80 text-xs leading-relaxed mb-3">
                Modèle du comportement d'un MFC complet.
              </p>
              <div className="flex flex-wrap gap-1 mb-3">
                <span className="bg-blue-500 bg-opacity-20 text-blue-200 px-2 py-1 rounded-full text-xs">C++</span>
                <span className="bg-purple-500 bg-opacity-20 text-purple-200 px-2 py-1 rounded-full text-xs">Python</span>
              </div>
              <button className="bg-white bg-opacity-10 text-white px-3 py-1 rounded-full text-xs hover:bg-opacity-20 transition-all duration-300 border border-white border-opacity-20">
                Non public
              </button>
            </div>

            {/* Projet 2 */}
            <div className="bg-white bg-opacity-10 rounded-xl border border-white border-opacity-10 p-4 hover:bg-opacity-15 transition-all duration-300">
              <div className="h-20 bg-gradient-to-br from-green-500 to-blue-600 rounded-lg mb-3 flex items-center justify-center">
                <div className="text-white text-xl poppins-bold">📊</div>
              </div>
              <h3 className="text-lg poppins-medium text-white mb-2">StudyCoop</h3>
              <p className="text-white opacity-80 text-xs leading-relaxed mb-3">
                Site web de partage de projets open-source.
              </p>
              <div className="flex flex-wrap gap-1 mb-3">
                <span className="bg-blue-500 bg-opacity-20 text-blue-200 px-2 py-1 rounded-full text-xs">React</span>
                <span className="bg-purple-500 bg-opacity-20 text-purple-200 px-2 py-1 rounded-full text-xs">Express</span>
                <span className="bg-yellow-500 bg-opacity-20 text-yellow-200 px-2 py-1 rounded-full text-xs">Auth / MongoDB</span>
              </div>
              <a href='https://studycoop.fr' className="bg-white bg-opacity-10 text-white px-3 py-1 rounded-full text-xs hover:bg-opacity-20 transition-all duration-300 border border-white border-opacity-20">
                Voir le projet
              </a>
            </div>

            {/* Projet 3 */}
            <div className="bg-white bg-opacity-10 rounded-xl border border-white border-opacity-10 p-4 hover:bg-opacity-15 transition-all duration-300">
              <div className="h-20 bg-gradient-to-br from-red-500 to-pink-600 rounded-lg mb-3 flex items-center justify-center">
                <div className="text-white text-xl poppins-bold">🎮</div>
              </div>
              <h3 className="text-lg poppins-medium text-white mb-2">
BetterTomuss / Lgrndev</h3>
              <p className="text-white opacity-80 text-xs leading-relaxed mb-3">
                BetterTomuss reprend le site web "Tomuss" de l'Université Claude Bernard mais avec un affichage plus stylistique et les fonctionnalités supplémentaires
              </p>
              <div className="flex flex-wrap gap-1 mb-3">
                <span className="bg-red-500 bg-opacity-20 text-red-200 px-2 py-1 rounded-full text-xs">React</span>
              </div>
              <a href="https://lgrndev.github.io" className="bg-white bg-opacity-10 text-white px-3 py-1 rounded-full text-xs hover:bg-opacity-20 transition-all duration-300 border border-white border-opacity-20">
                Voir le projet
              </a>
            </div>

            {/* Projet 4 */}
            <div className="bg-white bg-opacity-10 rounded-xl border border-white border-opacity-10 p-4 hover:bg-opacity-15 transition-all duration-300">
              <div className="h-20 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-lg mb-3 flex items-center justify-center">
                <div className="text-white text-xl poppins-bold">🤖</div>
              </div>
              <h3 className="text-lg poppins-medium text-white mb-2">
PhyRank</h3>
              <p className="text-white opacity-80 text-xs leading-relaxed mb-3">
                PhyRank est une plateforme en développement dédiée aux étudiants en physique, offrant une gamme d'exercices du niveau Bac+1 à Bac+5. Notre système innovant intègre des fonctionnalités ludiques pour enrichir l'expérience d'apprentissage, accompagnées d'un classement global pour stimuler la progression académique.

              </p>
              <div className="flex flex-wrap gap-1 mb-3">
                <span className="bg-purple-500 bg-opacity-20 text-purple-200 px-2 py-1 rounded-full text-xs">Python</span>
                <span className="bg-orange-500 bg-opacity-20 text-orange-200 px-2 py-1 rounded-full text-xs">Transformers</span>
                <span className="bg-green-500 bg-opacity-20 text-green-200 px-2 py-1 rounded-full text-xs">FastAPI</span>
              </div>
              <button className="bg-white bg-opacity-10 text-white px-3 py-1 rounded-full text-xs hover:bg-opacity-20 transition-all duration-300 border border-white border-opacity-20">
                En développement
              </button>
            </div>

          </div>
        </div>
      </section>

      {/* Slide 6 - Contact */}
      <section className="w-full h-screen snap-start relative z-10 flex flex-col items-center justify-center p-4">
        <div className="w-2/3 max-w-screen-lg text-center">
          <h2 className="text-5xl poppins-bold text-white glow-shadow mb-8">Contact</h2>
          <div className="bg-white bg-opacity-10 rounded-2xl border border-white border-opacity-10 p-8">
            <p className="text-xl poppins-light text-white mb-8">
              Intéressé par une collaboration ? N'hésitez pas à me contacter !
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
              <button className="bg-white py-4 px-8 text-black poppins-regular rounded-full hover:bg-opacity-90 transition-all duration-300">
                📧 lucaslangrand@icloud.com
              </button>
              <a
                href="https://www.linkedin.com/in/lucas-langrand"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white bg-opacity-10 py-4 px-8 text-white border border-white border-opacity-10 poppins-regular hover:bg-opacity-30 transition-all duration-300 hover:border-opacity-40 rounded-full"
              >
                💼 LinkedIn
              </a>
              <a href="https://github.com/lgrndev" className="bg-white bg-opacity-10 py-4 px-8 text-white border border-white border-opacity-10 poppins-regular hover:bg-opacity-30 transition-all duration-300 hover:border-opacity-40 rounded-full">
                🐙 GitHub
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default App;
